export const FIELD_NAMES = {
    ACCOUNT: 'Account',
    CHOOSE_ACCOUNT: 'Choose Account',
    IMPORT: 'Import',
    CROSS: 'Cross',
    INSURANCE: 'Insurance',
    RECEIVER_PAYS: 'ReceiverPays',
    DANGEROUS_GOODS: 'DangerousGoods',
    DRY_ICE: 'DryIce',
    PACKAGE_DIMENSIONS: 'PackageDimensions',
    PACKAGING_TYPE: 'PackagingType',
    TRANSIT_TIME: 'TransitTime',
    PRICE: 'Price',
    EXPORT_REASONS: 'ExportReasons',
    INCOTERMS: 'Incoterms',
    NO_INSURANCE: 'NoInsurance',
    COMPANY: 'Company',
    IMPORTER_OF_RECORD: 'ImporterOfRecord',
    SHIPMENT_PACKAGING: 'ShipmentPackaging',
    BOOK_EXPORT_PICKUP: 'BookExportPickup',
    MULTI_REFERENCE: 'MultiReference',
    SENDERS_REFERENCE: 'SendersReference',
    RECEIVERS_REFERENCE: 'ReceiversReference',
    SHOW_LEGACY_SHIPPING_OPTIONS: 'ShowLegacyShippingOptions',
    PRE_BOOKING: 'Prebooking',
    SHOW_ALTERNATIVE_TRANSPORT_PRODUCTS: 'ShowAlternativeTransportProducts',
    REQUIRE_INVOICE: 'MandatoryInvoice',
    SOLDTO: 'SoldTo',
    BROKER: "BrokerSelection",
    IS_PRIVATE_OR_BUSINESS: 'B2CShipment',
    RETURN_SHIPMENT: 'ReturnShipment',
    ADDITIONAL_MESSAGE: 'ShowAdditionalMessage',
    SHOW_INITIALS_AND_DEPARTMENT: 'ShowInitialsAndDepartmentSwitch',
    SHIP_FROM_BOOKING_INITIALS: 'OnBehalfOfInitials',
    SHIP_FROM_BOOKING_DEP: 'OnBehalfOfDepartment',
    MANUEL_BOOKING: 'ManualBooking',
};

export const EVENTS = {
    SET_SENDER: 'setSender',
    SET_RECEIVER: 'setReceiver',
    SET_PICKUP: 'setPickup',
    SHIPMENT_TYPE_UPDATE: 'shipmentTypeUpdate',
    NEWS_LOADED: 'newsLoaded',
    SET_USER_BRANCH: 'setUserBranch',
    USER_LOADED: 'userLoaded',
    UNKNOWN_USER: 'unknownUser',
    SHIPMENT_PROTOTYPE_LOADED: 'shipmentPrototypeLoaded',
    SHIPMENT_SET: 'shipmentSet',
    SET_DEFAULT_VALUES: 'setDefaultValues',
    SET_TRANSITTIME: 'setTransitTime',
    SET_SERVICE_PRICES: 'setServicePrices',
    RESET: 'reset'
};

export const BOOKING_TYPES = {
    ERROR_BOOKING: 'ErrorBooking',
    PRE_BOOKING: 'PreBooking',
    FINAL_BOOKING: 'FinalBooking',
    QUOTE_BOOKING: 'QuoteBooking'
};
